import React from 'react';
import { Link } from '../../../../components/navigation';
import { Table, ColumnType, ContentPosition, Icon, Button } from '@doxyme/ui';
import { useDispatch } from 'react-redux';
import { deleteById } from '../../actions';
import { addToast } from '../../../core/actions';
import { ToastType } from '../../../core';
export const AdminSsoTable = ({ ssoServices }) => {
    const dispatch = useDispatch();
    const onDelete = async (id) => {
        try {
            await dispatch(deleteById(id));
        }
        catch (e) {
            dispatch(addToast(ToastType.error, e.message));
        }
    };
    return (<Table body={ssoServices} columns={[
            {
                correspondingKey: 'name',
                id: 1,
                title: 'Name',
                type: ColumnType.TEXT,
            },
            {
                correspondingKey: 'redirectUrl',
                id: 2,
                title: 'Redirect URL',
                type: ColumnType.TEXT,
            },
            {
                correspondingKey: 'identityAttrs',
                id: 3,
                title: 'Identity attributes',
                type: ColumnType.TEXT,
            },
            {
                correspondingKey: 'jwtPrivateKey',
                id: 4,
                title: 'Private Key',
                type: ColumnType.TEXT,
            },
            {
                id: 5,
                title: '',
                type: ColumnType.COMPONENT,
                contentPosition: ContentPosition.CENTER,
                columnRenderer: (ssoService) => (<div>
              <Link to={`/account/admin/sso-services/edit/${ssoService.id}`}>
                Edit
              </Link>
            </div>),
            },
            {
                id: 6,
                title: '',
                type: ColumnType.COMPONENT,
                contentPosition: ContentPosition.CENTER,
                columnRenderer: (ssoService) => (<Button iconOnly={true} btnStyle="flat" size="small" onClick={() => void onDelete(ssoService.id)}>
              <Icon name="delete" size="x-small"/>
            </Button>),
            },
        ]}/>);
};
